import StopVocTable from "./components/StopVocTable";

const StopVoc = () => {
  return <StopVocTable />;
};

export default StopVoc;
